import { AdoptionWidget } from "./AdoptionWidget/AdoptionWidget";
import { CommunityFeedInsightsWidget } from "./CommunityFeedInsightsWidget/CommunityFeedInsightsWidget";
import { CompanyAdoptionWidget } from "./CompanyAdoptionWidget/CompanyAdoptionWidget";
import { EngagementWidget } from "./EngagementWidget/EngagementWidget";
import { FahWidget } from "./FahWidget/FahWidget";
import { SocialContributionWidget } from "./SocialContributionWidget/SocialContributionWidget";

// Used for V2 dashboard (Currently)
export const Analytics_LEGACY = {
  AdoptionWidget,
  CommunityFeedInsightsWidget,
  CompanyAdoptionWidget,
  FahWidget,
  EngagementWidget,
  SocialContributionWidget,
};
